import { createFileRoute } from "@tanstack/react-router";

import { ChannelsPage } from "@/features/money/pages";

export const Route = createFileRoute("/_app/money/channels")({
  component: ChannelsPage,
});
